import {
  TextField
} from '@material-ui/core';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import React, { useEffect, useState } from "react";
import CategorySelectField from "../../../components/CategorySelectField";
import { RUB } from "../../../utils/strings";
import ArticleField from './ArticleField';
import GridField from './GridField';
import PackInCardboardField from "./PackInCardboardField";
import PackInBubleWrapField from "./PackInBubleWrapField";
import CountryField from "./CountryField";
import BarcodesField from "./BarcodesField";

const AllFields = ({onEmitFields, hasBoxProduct, products}) => {
    const country = products.find(product => typeof product?.country_code === 'string')?.country_code || null;
    const [stateFields, setStateFields] = useState({
        type: 2,
        categoryId: undefined,
        name: '',
        description: '',
        articles: [],
        price: '',
        oldPrice: '',
        is_pack_in_cardboard: false,
        is_pack_in_bubble_wrap: !hasBoxProduct,
        country: country,
        barcodes: [],
    });

  useEffect(() => {    
    onEmitFields(stateFields);
  }, [stateFields]);
  
  const handleField: void = (name, value) => {
    setStateFields({...stateFields, [name]: value})
  };


  return (
    <>
      <GridField label={'Название'} required>
        <TextField
          label=''
          variant='outlined'
          value={stateFields.name}
          onChange={(event) => handleField('name', event.target.value)}
          size={'small'}
          fullWidth
        />
      </GridField>
      <GridField label={'Описание'}>
        <TextField
          label=''
          variant='outlined'
          value={stateFields.description}
          onChange={(event) => handleField('description', event.target.value)}
          size={'small'}
          fullWidth
          multiline={true}
          minRows={10}
          maxRows={10}
        />
      </GridField>
      <GridField label={'Артикулы'} required>
        <ArticleField updateArticle={(value) => handleField('articles', value)} chips={stateFields.articles} />
      </GridField>
      <GridField label={'Категория'} required>
        <CategorySelectField
          value={stateFields.categoryId}
          AutocompleteProps={{
            fullWidth: true,
            placeholder: "Выберите категорию",
            size: "small",
          }}
          onChange={(value) => handleField('categoryId', value)}
        />
      </GridField>
      <GridField label={'Цена'}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextField
                label='Розничная цена'
                variant='outlined'
                value={stateFields.price}
                onChange={(event) => handleField('price', event.target.value)}
                size={'small'}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <Typography variant="subtitle1">{RUB}</Typography>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label='Старая цена'
                variant='outlined'
                value={stateFields.oldPrice}
                onChange={(event) => handleField('oldPrice', event.target.value)}
                size={'small'}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <Typography variant="subtitle1">{RUB}</Typography>
                  )
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </GridField>
        <GridField
            label={"Штрих-код"}
        >
            <BarcodesField barcodes={stateFields.barcodes} changeValue={(value) => handleField('barcodes', value)} />
        </GridField>
        <GridField
            label={"Страна производства"}
            help={"Данный параметр является обязательным для автоматического импорта товара на Яндекс.Маркет"}
        >
            <CountryField country={stateFields.country} changeCountry={(value) => handleField('country', value)} />
        </GridField>
        <GridField
            required={!hasBoxProduct}
            label={'Упаковка товара в воздушно-пупырчатую пленку'}
            help={`Если включить обе опции "Упаковка в картон" и "Упаковка в воздушно-пупырчатую плёнку", то товар будет упакован в два вида одновременно. (подходит для хрупких товаров). Если выключить обе опции -- товар не будет дополнительно упакован, этикетка маркеплейса будет приклеена на заводскую упаковку (подходит для товаров в крепкой упаковке), данный вид упаковки должен соответсвовать требованию упаковки МП.`}
        >
            <PackInBubleWrapField updatePackingBubble={(value) => handleField('is_pack_in_bubble_wrap', value)} isPack={stateFields.is_pack_in_bubble_wrap} />
        </GridField>
        <GridField
            required={!hasBoxProduct}
            label={"Упаковка товара в картон"}
            help={`Если включить обе опции "Упаковка в картон" и "Упаковка в воздушно-пупырчатую плёнку", то товар будет упакован в два вида одновременно. (подходит для хрупких товаров). Если выключить обе опции -- товар не будет дополнительно упакован, этикетка маркеплейса будет приклеена на заводскую упаковку (подходит для товаров в крепкой упаковке), данный вид упаковки должен соответсвовать требованию упаковки МП.`}
        >
            <PackInCardboardField updatePackingCardboard={(value) => handleField('is_pack_in_cardboard', value)} isPack={stateFields.is_pack_in_cardboard} />
        </GridField>
    </>
  )
}

export default AllFields